import introBackground from "../assets/images/Logo_Intro.png";
import introDesc from "../assets/images/Tittle_Intro1.png";
import introDescPortrait from "../assets/images/Tittle_Intro2.png";
import useScreenOrientation from './helpers/useScreenOrientation';

export default function Intro({ isVisible, setView }: any) {

  const isLandscape = useScreenOrientation();

  return (
    <div className={`full-intro-container ${isVisible === true ? 'active' : 'hidden'}`}>
      <div className={`intro-title ${isLandscape ? '' : 'portrait'}`}>
        <img className={`intro-title-img ${isLandscape ? '' : 'portrait'}`} src={introBackground} alt=''/>
      </div>
      <div className={`intro-description ${isLandscape ? '' : 'portrait'}`}>
        <img className={`intro-description-img ${isLandscape ? '' : 'portrait'}`} src={isLandscape ? introDesc: introDescPortrait} alt=''/>
        {/* <div className={`intro-description-text ${isLandscape ? '' : 'portrait'}`}>
          Compra con tu cupo Sistecrédito o abona a tus cuotas y juega para ganar un viaje a <b>Punta Cana</b>, una moto <b>Yamaha Crypton</b> o bonos de mercado. <a className='intro-description-link' href='https://www.sistecredito.com/terminos-y-condiciones-el-mundo-del-si/' target='_blank' rel='noreferrer'>*Aplican términos y condiciones.</a>
        </div> */}
      </div>
      
      <div className={'intro-bottom'} onClick={() => setView("UserForm")} > {/* Instructions */}
        <div className='intro-bottom-text'>¡JUGAR!</div>
      </div>
    </div>
  );
}